<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Gestorbenes Erz</h3>
<p class="vers">Ich weiß nicht, was soll es bedeuten,<br class="calibre2"/>
daß meine Träne rinnt<br class="calibre2"/>
zuweilen, wenn ferne das Läuten<br class="calibre2"/>
der Glocke, der Glocke beginnt.</p>
<p class="vers">Die Sonne umhüllt sich mit Rosen<br class="calibre2"/>
und taucht ins Schilf am Ried,<br class="calibre2"/>
die Wellen, die leisen, die losen,<br class="calibre2"/>
sie flüstern ins heilige Lied.</p>
<p class="vers">Die Wellen, die Gräser, die Föhren,<br class="calibre2"/>
sie lauschen rings umher.<br class="calibre2"/>
Die Menschen, sie lieben und hören<br class="calibre2"/>
die Glocke, die Glocke nicht mehr.</p>
<p class="vers">Es geht, ein verlassener Armer,<br class="calibre2"/>
ihr Ton durchs öde Land:<br class="calibre2"/>
Er predigt vom großen Erbarmer,<br class="calibre2"/>
den Gott aus dem Himmel gesandt.</p>
<p class="vers">Er predigt das Licht und den Frieden,<br class="calibre2"/>
den Christus hat gebracht,<br class="calibre2"/>
denn wieder gebietet hienieden<br class="calibre2"/>
der grausame Krieg und die Nacht.</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page30" title="wedi/Konmax"></a> Du hallende, dröhnende Klage<br class="calibre2"/>
am stillen Gotteshaus;<br class="calibre2"/>
du Geist der vergangenen Tage,<br class="calibre2"/>
dein Reich der Versöhnung ist aus!</p>
<p class="vers">Wohl hast du zu Grabe geleitet<br class="calibre2"/>
manch müdes Menschenherz,<br class="calibre2"/>
nun ist auch dein Hügel bereitet,<br class="calibre2"/>
du armes, gestorbenes Erz.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0015.vue?adf024ca